import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    profile: {},
    positions: [],
    deptAccess: [],
    users: [],
    importStatus: {
      status: '',
    },
    tempId: null,
    tempProfile: {},
    tempPositions: [],
    tempDeptAccess: [],
  },
  getters: {
    screens: () => (roles) => {

      let screens = [];

      if (roles.includes('Filer')) {
        screens.push('edit-user-profile');
      }

      if (roles.includes('DeptHead')) {
        screens.push('edit-user-profile');
        screens.push('filer-administration');
        screens.push('reports');
        screens.push('pdf-test');
        screens.push('filing-data');
      }

      if (roles.includes('SysAdmin')) {
        screens.push('edit-user-profile');
        screens.push('screens-and-menus');
        screens.push('filer-administration');
        screens.push('reports');
        screens.push('import-filers');
        screens.push('pdf-test');
        screens.push('filing-data');
      }

      return Array.from(new Set(screens));

    },
    hasScreenAccess: (state, getters, rootState, rootGetters) => (screen) => {

      let roles = rootState.login.loggedIn.roles;
      let screens = [ ...getters['screens'](roles) ];
      let filingScreens = [];
      if (roles.includes('Filer')) {
        filingScreens.push(...rootGetters['filings/filingScreens']('profile'));
        filingScreens.push(...rootGetters['filings/filingScreens']('filing'));
      }
      let requiredScreens = [ ...screens, ...filingScreens ];

      if (requiredScreens.includes(screen)) {
        return true;
      }
      return false;
    },
  },
  mutations: {
    setUsers (state, users) {
      Vue.set(state, 'users', users);
    },
    setUserPositions(state, user) {
      if (user.isTemp) {
        Vue.set(state, 'tempPositions', user.data);
      } else {
        Vue.set(state, 'positions', user.data);
      }
    },
    setUserDepts(state, user) {
      if (user.isTemp) {
        Vue.set(state, 'tempDeptAccess', user.data);
      } else {
        Vue.set(state, 'deptAccess', user.data);
      }
    },
    setUserProfile(state, user) {
      for (let key in user.data) {
        if (user.isTemp) {
          Vue.set(state.tempProfile, key, user.data[key]);
        } else {
          Vue.set(state.profile, key, user.data[key]);
        }
      }
    },
    setImportStatus(state, status) {
      Vue.set(state, 'importStatus', status);
    },
    setTempId (state, id) {
      Vue.set(state, 'tempId', id);
    },
  },
  actions: {
    fetchUserPositions({ commit, rootState }, userId) {
      let isTempUser = true;
      if (!userId) {
        userId = rootState.login.loggedIn.id;
        isTempUser = false;
      }
      return this.$axios.get(`${rootState.endpoints.users}/${userId}/user-positions`).then(response => {
        commit('setUserPositions', { isTemp: isTempUser, data: response.data });
      });
    },
    fetchUserProfile({ commit, rootState }, userId) {
      let isTempUser = true;
      if (!userId) {
        userId = rootState.login.loggedIn.id;
        isTempUser = false;
      }
      return this.$axios.get(`${rootState.endpoints.users}/${userId}`).then((response) => {
        return commit('setUserProfile', { isTemp: isTempUser, data: response.data });
      }).catch(error => {
        return error.message;
      });
    },
    searchUsers({ rootState }, query) {
      return new Promise((resolve, reject) => {
        return this.$axios({
          method: 'get',
          url: `${rootState.endpoints.admin.usersSearch}`,
          params: query,
        }).then(response => {
          return resolve(response.data);
        }).catch(error => {
          console.warn(error);
          return reject([]);
        });
      });
    },
    fetchUserDepts ({ commit, rootState }, userId) {
      let isTempUser = true;
      if (!userId) {
        userId = rootState.login.loggedIn.id;
        isTempUser = false;
      }
      return this.$axios.get(`${rootState.endpoints.admin.users}/${userId}/admins-departments`).then((response) => {
        return commit('setUserDepts', { isTemp: isTempUser, data: response.data });
      }).catch(error => {
        return error.message;
      });
    },
    saveUserDepts({ rootState }, { userId, agencyIds }) {
      if (!userId) {
        userId = rootState.login.loggedIn.id;
      }
      return this.$axios({
        url: `${rootState.endpoints.admin.users}/${userId}/admins-departments`,
        method: 'post',
        data: agencyIds,
      }).then(() => {
        return true;
      }).catch(error => {
        return error.message;
      });
    },
    async registerNewUser ({ rootState }, { fields }) {
      let data = fields;

      // if (data.homeState) {
      //   data.homeState = data.homeState.toString();
      // }

      // if (data.countyOfResidence) {
      //   data.countyOfResidence = data.countyOfResidence.toString();
      // }

      try {
        let response = await this.$axios({
          method: 'post',
          url: `${rootState.endpoints.users}`,
          data: data,
        });
        return response;
      } catch (error) {
        if (error.response.status === 409) {
          this.$error("The e-mail used has already been registered. Please, use a different e-mail address or contact support.");
        } else {
          this.$error("There was an error while attempting to create your new account. Please, try again or contact support if you are unable to proceed.");
        }
        return false;
      }
    },
    registerNewAdminUser({ rootState }, { fields }) {
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'post',
          url: `${rootState.endpoints.admin.users}`,
          data: fields,
        }).then((response) => {
          resolve(response);
        }).catch(error => {
          console.warn(error);
          reject(error);
        });
      });
    },
    updateUserProfile ({ rootState }, { fields, userId }) {
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'patch',
          url: `${rootState.endpoints.users}/${userId}`,
          data: fields,
        }).then(() => {
          resolve(true);
        }).catch(error => {
          this.$warning(error.message);
          reject(error);
        });
      });
    },
    updateUserPassword ({ rootState }, passwords) {
      return new Promise((resolve, reject) => {
        this.$axios({
          url: `${rootState.endpoints.updatePassword}`,
          method: 'put',
          data: passwords,
        }).then(response => {
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    saveUserPositions({ rootState }, { positions, userId }) {

      return new Promise(async (resolve, reject) => {
        let cud = {
          post: [],
          put: [],
          delete: [],
        };

        positions.forEach(position => {
          if (position.cud) {
            if (position.cud === 'post') {
              position.id = undefined;
              position.userId = userId;
              cud[position.cud].push(position);
            } else if (position.cud === 'put') {
              cud[position.cud].push(position);
            } else if (position.cud === 'delete') {
              cud[position.cud].push(position.id);
            }
          }
        });

        let promises = [];
        let endpoint = `${rootState.endpoints.users}/${userId}/user-positions`;

        for (let type in cud) {
          if (cud[type].length > 0 && type !== 'delete') {
            promises.push(this.$axios({
              method: type,
              url: endpoint,
              data: cud[type],
            }).catch(error => {
              reject(error);
            }));
          }
        }

        //Split saving request to keep "delete" from running before the other requests.
        //This stops the backend rule (user needs to have at least one position) from triggering
        await Promise.all(promises);

        if (cud['delete'].length > 0) {
          await this.$axios({
            method: 'delete',
            url: endpoint,
            data: cud['delete'],
          }).catch(error => {
            reject(error);
          });
        }

        resolve(true);

      });
    },
    async checkBatchStatus({ commit }) {
      try {
        let response = await this.$axios.get('admin/users/status');
        commit('setImportStatus', response.data);
      } catch (e) {
        this.$error(e.message);
      }
    },
    async startImportBatchProcesss(ctx, batchID) {
      try {
        let response = await this.$axios.post(`admin/users/process/${batchID}`);
        return response;
      } catch (e) {
        this.$error(e.message);
      }

    },
    async stopImportBatchProcesss(ctx, batchID) {
      try {
        await this.$axios.post(`admin/users/cancel/${batchID}`);
        return;
      } catch(error) {
        this.$error(error.message);
        return;
      }
    },
    async importUsers({ commit, dispatch }, users) {
      try {
        let response = await this.$axios.post('admin/users/import', users);
        if (response.data.status === 'Saved') {
          commit('setImportStatus', { status: 'Saved' });
          await dispatch('startImportBatchProcesss', response.data.id);
        }
        return response;
      } catch (e) {
        this.$error(e.message);
      }
    },
    // eslint-disable-next-line
    async genPasswordResetLink ({ dispatch }, user) {
      try {
        let response = await this.$axios({
          method: 'post',
          url: 'admin/generate-password-reset-link',
          data:  {
            filerId: user,
          },
        });
        try {
          return response.data.passwordResetLink;
        } catch (e) {
          this.$error(response.status);
        }
      } catch (e) {
        this.$error(e.message);
      }
    },
  },
};
